import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getUserIn2nAPI } from './api';

export const GET_USER_IN_2N = 'getUserIn2N';

export function useGetUserIn2n(userEmail) {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery(
    [GET_USER_IN_2N, tenantId, userEmail],
    () => getUserIn2nAPI(userEmail),
    {
      enabled: !!userEmail,
    },
  );

  const hasRfIdTags = data?.AccessCredentials?.Cards && data.AccessCredentials.Cards.length > 0;

  const formattedRfIdTags = hasRfIdTags ? data?.AccessCredentials?.Cards?.map((card) => ({
    name: card,
    value: card,
  })) : [{ name: '', value: '' }];

  return {
    user: data,
    isSuspended: data?.IsSuspended,
    rfIdTags: formattedRfIdTags,
    isLoading,
    isFetching,
    isError,
  };
}

